import React from "react";

export default () => (
  <>
    <header className="masthead">
      <div className="container">
        <div className="grid">
          <div className="row">
            <div className="col-lg-7 header-column my-5">
              <div className="header-content my-5 p-3">
                <h2 className="mb-5">
                  CarveWizard is an experimental GPU G-code planner that takes
                  3D geometry and outputs milling tool paths.
                </h2>
                <p>
                  GPUs used for AI come with substantial amounts of video RAM,
                  which enables us to operate on the part <i> volume </i>
                  rather than the
                  <i> surface </i> as a B-REP kernel would.
                </p>
                <p>
                  This enables large parallelization speedups and also produces
                  paths which have been 100% collision checked and shortcut in a
                  volume-aware way so that every segment is cutting.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section className="py-5 video-section">
      <div className="video-section-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="video-embed">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/efMCUcesigo"
                    title="CarveWizard: CAM For Robots"
                    allowFullScreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);
